<template>
    <div class="accordion" id="package-block-parent">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button" type="button" @click="$helper.toggleAccordion(3, true);">
                    {{ $helper.trans('Package') }}
                </button>
            </h2>
            <div id="package-block-content" class="accordion-collapse collapse" aria-labelledby="package-block" data-parent="#package-block-parent">
                <div class="accordion-body" :class="{ 'pt-0': $store.state.inClientAdmin }">
                    <div class="options-line-column-full-with">
                        <label class="packet-name">
                            {{ $helper.trans('Package_type') }}
                            <i class="fa fa-question-circle info-question-circle">
                                <div class="custom-popover-wrapper">
                                    <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Package_type_info')"></div>
                                </div>
                            </i>
                        </label>
                        <div class="select-package-template" v-if="packageTemplates">
                            <select2-component
                                :values="packageTemplates"
                                :placeholder="$helper.trans('Available_package_templates')"
                                classes="input-big w-100 select-style-ups"
                                v-model="selectedPackageTemplateId"                                
                                :packageTemplate="true"
                                :noLang="true"
                                dropDownClass="select2_customization"                                     
                            ></select2-component>                            
                        </div>  
                        <div class="options-navig-block packageType_input">
                            <div class="options-navig-column custom-radio-border">
                                <input type="radio" v-model="$store.state.packageType" value="01" id="packet-1" class="input-country input-big">
                                <label for="packet-1" id="label-packet-1">{{ $helper.trans('Calculator_envelope') }}</label>
                            </div>
                            <div class="options-navig-column custom-radio-border">
                                <input type="radio" v-model="$store.state.packageType" value="04" id="packet-3" class="input-country input-big">
                                <label for="packet-3" id="label-packet-3">{{ $helper.trans('UPS_Package') }}</label>
                            </div>
                            <div class="options-navig-column custom-radio-border">
                                <input type="radio" v-model="$store.state.packageType" value="02" id="packet-2" class="input-country input-big" checked="">
                                <label for="packet-2" id="label-packet-2">{{ $helper.trans('Box') }}</label>
                            </div>                            
                        </div>
                    </div>
                    <div class="client-admin-package-dimensions-line">
                        <label class="options-line-label size-16">{{ $helper.trans('Package_dimensions') }}</label>
                        <package-dimensions-line v-for="(packagesDimension, packageIndex) in $store.state.packagesDimensions" :key="packageIndex" :index="packageIndex" />
                        <div class="mt-3 maximum-packets-warning" style="display: none;">
                            <p class="alert alert-danger">{{ $helper.trans('Reached_maximum_packets_limit') }}</p>
                        </div>
                    </div>
                    <div class="link-block">
                        <button type="button" @click="$helper.toggleAccordion(2, true);" class="link link-left">{{ $helper.trans('Receiving_address') }}</button>
                        <button type="button" @click="nextStep()" class="link link-right">{{ $helper.trans('Shipping_option_selection') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function() {
        return {
            selectedPackageTemplateId: '',
            packageTemplates: []
        };
    },
    methods: {
        nextStep() {            
            this.$helper.toggleAccordion(4, true);
        },
        checkDimension: function(number) {
            return number !== undefined && number !== null ? parseFloat(number) : 0;
        }   
    },
    created: function() {
        let vueThis = this;  
        vueThis.packageTemplates = vueThis.$store.state.userSettings.dimensions;
        $.each(vueThis.packageTemplates, function (mainIndex, template) { 
            if (template.packages !== undefined) {
                $.each(template.packages, function (index, item) { 
                    vueThis.packageTemplates[mainIndex].packages[index].weight = vueThis.checkDimension(item.weight);
                    vueThis.packageTemplates[mainIndex].packages[index].length = vueThis.checkDimension(item.length);
                    vueThis.packageTemplates[mainIndex].packages[index].width = vueThis.checkDimension(item.width);     
                    vueThis.packageTemplates[mainIndex].packages[index].height = vueThis.checkDimension(item.height); 
                });   
            }                 
        });       
    },
    watch: {
        'selectedPackageTemplateId': function() {
            let vueThis = this;  
            if (vueThis.selectedPackageTemplateId) {
                if (this.packageTemplates[this.selectedPackageTemplateId] !== undefined) {                    
                    const packagesTemplate = vueThis.packageTemplates[vueThis.selectedPackageTemplateId];
                    vueThis.$store.state.packageType = packagesTemplate.package_type;
             
                    if (packagesTemplate.packages !== undefined) {                                            
                        vueThis.$store.state.packagesDimensions = _.cloneDeep(packagesTemplate.packages);                    
                    }                 
                }
            }
        },
    }
}
</script>
